import MiniCartView from '../views/miniCart.view.html?raw';

class MiniCartController {
    constructor($scope, $document, $element, $location, sharedData, translateService) {
        this.$scope = $scope;
        this.$document = $document;
        this.$element = $element;
        this.$location = $location;
        this.sharedData = sharedData;
        this.translate = translateService;
        this.showCart = false;
    }

    $onInit() {
        const documentClickOutside = (e) => {
            if (this.showCart === false) {
                return;
            }

            if (this.$element !== e.target && !this.$element[0].contains(e.target)) {
                this.showCart = false;

                this.$scope.$apply();
            }
        };

        this.$document.on('click', documentClickOutside);
    }

    $onChanges() {

    }

    remove(item) {
        this.sharedData.cart.remove(item);

        if (this.$location.absUrl().endsWith('/' + this.translate.t('routes.cart'))) {
            window.location.pathname = this.translate.t('routes.cart');
        }

        if (this.$location.absUrl().endsWith('/' + this.translate.t('routes.checkout'))) {
            window.location.pathname = this.translate.t('routes.checkout');
        }
    }

    getCartUrl() {
        return this.translate.buildUrl('/' + this.translate.t('routes.cart'));
    }
}

let miniCartComponent = {
    bindings: {},
    template: MiniCartView,
    controller: MiniCartController
};

MiniCartController.$inject = ['$scope', '$document', '$element', '$location', 'sharedData', 'translateService'];

export default miniCartComponent;
